module.exports = __webpack_public_path__ + "static/img/bg01.17f5a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg01.jpg
// module id = LAhc
// module chunks = 1